/* CMS */
export const CMS_GET = "CMS_GET"
export const CMS_GET_APPLICATION_EDITING_VERSION =
  "CMS_GET_APPLICATION_EDITING_VERSION"
export const CMS_GET_ACCOUNT_EDITOR_VERSION = "CMS_GET_ACCOUNT_EDITOR_VERSION"
export const CMS_GET_SUCCESS = "CMS_GET_SUCCESS"
export const CMS_GET_ERROR = "CMS_GET_ERROR"
export const SET_CLIENT_ID = "SET_CLIENT_ID"
